import React, { Component } from 'react';
import Header from './../common/Header';
import { Button, Card } from 'reactstrap';
import { connect } from 'react-redux';
import { articleTitleChange, articleUrlChange, articlePictureChange, 
    saveArticle, pushArticle, articleTextClear, incrementCounter, clearCounter } from '../../actions/Articles/ArticleAction';

class PushArticles extends Component {

    componentWillMount() {
        this.props.articleTextClear();
        this.props.clearCounter();
    }

    onArticleTitleChange(event) {
        this.props.articleTitleChange(event);
    }

    onArticleUrlChange(event) {
        this.props.articleUrlChange(event);
    }

    onArticlePictureChange(event) {
        this.props.articlePictureChange(event);
    }

    render() {
        const { newArticle, users, counter } = this.props;
        return (
            <div>
                <Header />
                <div style={{ padding: 30, width: '100%', paddingTop: 40 }}>
                    <Card style={styles.cardStyle}>
                        <div className="row">
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Article Title
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={newArticle.title}
                                        onChange={event => this.onArticleTitleChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Article URL
                                    </h6>
                                    <textarea
                                        style={styles.textAreaStyle}
                                        value={newArticle.url}
                                        onChange={event => this.onArticleUrlChange(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Article Image URL
                                    </h6>
                                            <textarea
                                                style={styles.textAreaStyle}
                                                value={newArticle.picture}
                                                onChange={event => this.onArticlePictureChange(event.target.value)}
                                            />
                                </div>
                            </div>
                            <div className="col" />
                        </div>
                        <div className="row" style={{ paddingTop: 20, paddingLeft: 15 }}>
                            <div>
                                {
                                    counter === 0 ?
                                        <Button
                                            style={styles.buttonStyle}
                                            onClick={() => {
                                           this.props.saveArticle(users, newArticle.title, newArticle.url, newArticle.picture);
                                           this.props.incrementCounter(counter);
                                           }}
                                        >
                                            Save
                                        </Button> :
                                        <button type="button" className="btn btn-default" disabled="disabled">
                                            Save
                                        </button>
                                }
                            </div>
                            <div style={{ paddingLeft: 10 }}>
                                {
                                    counter === 0 ?
                                        <Button
                                            style={styles.buttonStyle}
                                            onClick={() => {
                                           this.props.pushArticle(users, newArticle.title, newArticle.url, newArticle.picture);
                                           this.props.incrementCounter(counter);
                                           }}
                                        >
                                            Save & Publish
                                        </Button> :
                                        <button type="button" className="btn btn-default" disabled="disabled">
                                            Save
                                        </button>
                                }
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

const styles = {
    inputStyle: {
        width: '75%',
        height: 40,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px'
    },
    textAreaStyle: {
        width: '75%',
        height: 75,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    cardStyle: {
        borderColor: '#7ed321',
        padding: 30,
        width: '90%',
        margin: 'auto',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    buttonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        newArticle: state.article.newArticle,
        articleTitle: state.article.articleTitle,
        counter: state.article.counter
    };
}

export default connect(mapStateToProps, { articleTitleChange, 
    articleTextClear, 
    articleUrlChange, 
    incrementCounter, 
    articlePictureChange, 
    saveArticle, 
    pushArticle, 
    clearCounter })(PushArticles);



// WEBPACK FOOTER //
// ./src/components/Articles/PushArticles.js